export const country = [
    {
        image: "AD.svg",
        dial_code: "+376"
    },
    {
        image: "AE.svg",
        dial_code: "+971"
    },
    {
        image: "AF.svg",
        dial_code: "+93"
    },
    {
        image: "AG.svg",
        dial_code: "+1268"
    },
    {
        image: "AI.svg",
        dial_code: "+1264"
    },
    {
        image: "AL.svg",
        dial_code: "+355"
    },
    {
        image: "AM.svg",
        dial_code: "+374"
    },
    {
        image: "AO.svg",
        dial_code: "+244"
    },
    {
        image: "AQ.svg",
        dial_code: "+672"
    },
    {
        image: "AR.svg",
        dial_code: "+54"
    },
    {
        image: "AS.svg",
        dial_code: "+1684"
    },
    {
        image: "AT.svg",
        dial_code: "+43"
    },
    {
        image: "AU.svg",
        dial_code: "+61"
    },
    {
        image: "AW.svg",
        dial_code: "+297"
    },
    {
        image: "AX.svg",
        dial_code: "+358"
    },
    {
        image: "AZ.svg",
        dial_code: "+994"
    },
    {
        image: "BA.svg",
        dial_code: "+387"
    },
    {
        image: "BB.svg",
        dial_code: "+1246"
    },
    {
        image: "BD.svg",
        dial_code: "+880"
    },
    {
        image: "BE.svg",
        dial_code: "+32"
    },
    {
        image: "BF.svg",
        dial_code: "+226"
    },
    {
        image: "BG.svg",
        dial_code: "+359"
    },
    {
        image: "BH.svg",
        dial_code: "+973"
    },
    {
        image: "BI.svg",
        dial_code: "+257"
    },
    {
        image: "BJ.svg",
        dial_code: "+229"
    },
    {
        image: "BL.svg",
        dial_code: "+590"
    },
    {
        image: "BM.svg",
        dial_code: "+1441"
    },
    {
        image: "BN.svg",
        dial_code: "+673"
    },
    {
        image: "BO.svg",
        dial_code: "+591"
    },
    {
        image: "BR.svg",
        dial_code: "+55"
    },
    {
        image: "BS.svg",
        dial_code: "+1242"
    },
    {
        image: "BT.svg",
        dial_code: "+975"
    },
    {
        image: "BW.svg",
        dial_code: "+267"
    },
    {
        image: "BY.svg",
        dial_code: "+375"
    },
    {
        image: "BZ.svg",
        dial_code: "+501"
    },
    {
        image: "CA.svg",
        dial_code: "+1"
    },
    {
        image: "CC.svg",
        dial_code: "+61"
    },
    {
        image: "CD.svg",
        dial_code: "+243"
    },
    {
        image: "CF.svg",
        dial_code: "+236"
    },
    {
        image: "CG.svg",
        dial_code: "+242"
    },
    {
        image: "CH.svg",
        dial_code: "+41"
    },
    {
        image: "CI.svg",
        dial_code: "+225"
    },
    {
        image: "CK.svg",
        dial_code: "+682"
    },
    {
        image: "CL.svg",
        dial_code: "+56"
    },
    {
        image: "CM.svg",
        dial_code: "+237"
    },
    {
        image: "CN.svg",
        dial_code: "+86"
    },
    {
        image: "CO.svg",
        dial_code: "+57"
    },
    {
        image: "CR.svg",
        dial_code: "+506"
    },
    {
        image: "CU.svg",
        dial_code: "+53"
    },
    {
        image: "CV.svg",
        dial_code: "+238"
    },
    {
        image: "CX.svg",
        dial_code: "+61"
    },
    {
        image: "CY.svg",
        dial_code: "+357"
    },
    {
        image: "CZ.svg",
        dial_code: "+420"
    },
    {
        image: "DE.svg",
        dial_code: "+49"
    },
    {
        image: "DJ.svg",
        dial_code: "+253"
    },
    {
        image: "DK.svg",
        dial_code: "+45"
    },
    {
        image: "DM.svg",
        dial_code: "+1767"
    },
    {
        image: "DO.svg",
        dial_code: "+1849"
    },
    {
        image: "DZ.svg",
        dial_code: "+213"
    },
    {
        image: "EC.svg",
        dial_code: "+593"
    },
    {
        image: "EE.svg",
        dial_code: "+372"
    },
    {
        image: "EG.svg",
        dial_code: "+20"
    },
    {
        image: "ER.svg",
        dial_code: "+291"
    },
    {
        image: "ES.svg",
        dial_code: "+34"
    },
    {
        image: "ET.svg",
        dial_code: "+251"
    },
    {
        image: "FI.svg",
        dial_code: "+358"
    },
    {
        image: "FJ.svg",
        dial_code: "+679"
    },
    {
        image: "FK.svg",
        dial_code: "+500"
    },
    {
        image: "FM.svg",
        dial_code: "+691"
    },
    {
        image: "FO.svg",
        dial_code: "+298"
    },
    {
        image: "FR.svg",
        dial_code: "+33"
    },
    {
        image: "GA.svg",
        dial_code: "+241"
    },
    {
        image: "GB.svg",
        dial_code: "+44"
    },
    {
        image: "GD.svg",
        dial_code: "+1473"
    },
    {
        image: "GE.svg",
        dial_code: "+995"
    },
    {
        image: "GF.svg",
        dial_code: "+594"
    },
    {
        image: "GG.svg",
        dial_code: "+44"
    },
    {
        image: "GH.svg",
        dial_code: "+233"
    },
    {
        image: "GI.svg",
        dial_code: "+350"
    },
    {
        image: "GL.svg",
        dial_code: "+299"
    },
    {
        image: "GM.svg",
        dial_code: "+220"
    },
    {
        image: "GN.svg",
        dial_code: "+224"
    },
    {
        image: "GP.svg",
        dial_code: "+590"
    },
    {
        image: "GQ.svg",
        dial_code: "+240"
    },
    {
        image: "GR.svg",
        dial_code: "+30"
    },
    {
        image: "GS.svg",
        dial_code: "+500"
    },
    {
        image: "GT.svg",
        dial_code: "+502"
    },
    {
        image: "GU.svg",
        dial_code: "+1671"
    },
    {
        image: "GW.svg",
        dial_code: "+245"
    },
    {
        image: "GY.svg",
        dial_code: "+595"
    },
    {
        image: "HK.svg",
        dial_code: "+852"
    },
    {
        image: "HN.svg",
        dial_code: "+504"
    },
    {
        image: "HR.svg",
        dial_code: "+385"
    },
    {
        image: "HT.svg",
        dial_code: "+509"
    },
    {
        image: "HU.svg",
        dial_code: "+36"
    },
    {
        image: "ID.svg",
        dial_code: "+62"
    },
    {
        image: "IE.svg",
        dial_code: "+353"
    },
    {
        image: "IL.svg",
        dial_code: "+972"
    },
    {
        image: "IM.svg",
        dial_code: "+44"
    },
    {
        image: "IN.svg",
        dial_code: "+91"
    },
    {
        image: "IO.svg",
        dial_code: "+246"
    },
    {
        image: "IQ.svg",
        dial_code: "+964"
    },
    {
        image: "IR.svg",
        dial_code: "+98"
    },
    {
        image: "IS.svg",
        dial_code: "+354"
    },
    {
        image: "IT.svg",
        dial_code: "+39"
    },
    {
        image: "JE.svg",
        dial_code: "+44"
    },
    {
        image: "JM.svg",
        dial_code: "+1876"
    },
    {
        image: "JO.svg",
        dial_code: "+962"
    },
    {
        image: "JP.svg",
        dial_code: "+81"
    },
    {
        image: "KE.svg",
        dial_code: "+254"
    },
    {
        image: "KG.svg",
        dial_code: "+996"
    },
    {
        image: "KH.svg",
        dial_code: "+855"
    },
    {
        image: "KI.svg",
        dial_code: "+686"
    },
    {
        image: "KM.svg",
        dial_code: "+269"
    },
    {
        image: "KN.svg",
        dial_code: "+1869"
    },
    {
        image: "KP.svg",
        dial_code: "+850"
    },
    {
        image: "KR.svg",
        dial_code: "+82"
    },
    {
        image: "KW.svg",
        dial_code: "+965"
    },
    {
        image: "KY.svg",
        dial_code: "+ 345"
    },
    {
        image: "KZ.svg",
        dial_code: "+77"
    },
    {
        image: "LA.svg",
        dial_code: "+856"
    },
    {
        image: "LB.svg",
        dial_code: "+961"
    },
    {
        image: "LC.svg",
        dial_code: "+1758"
    },
    {
        image: "LI.svg",
        dial_code: "+423"
    },
    {
        image: "LK.svg",
        dial_code: "+94"
    },
    {
        image: "LR.svg",
        dial_code: "+231"
    },
    {
        image: "LS.svg",
        dial_code: "+266"
    },
    {
        image: "LT.svg",
        dial_code: "+370"
    },
    {
        image: "LU.svg",
        dial_code: "+352"
    },
    {
        image: "LV.svg",
        dial_code: "+371"
    },
    {
        image: "LY.svg",
        dial_code: "+218"
    },
    {
        image: "MA.svg",
        dial_code: "+212"
    },
    {
        image: "MC.svg",
        dial_code: "+377"
    },
    {
        image: "MD.svg",
        dial_code: "+373"
    },
    {
        image: "ME.svg",
        dial_code: "+382"
    },
    {
        image: "MF.svg",
        dial_code: "+590"
    },
    {
        image: "MG.svg",
        dial_code: "+261"
    },
    {
        image: "MH.svg",
        dial_code: "+692"
    },
    {
        image: "MK.svg",
        dial_code: "+389"
    },
    {
        image: "ML.svg",
        dial_code: "+223"
    },
    {
        image: "MM.svg",
        dial_code: "+95"
    },
    {
        image: "MN.svg",
        dial_code: "+976"
    },
    {
        image: "MO.svg",
        dial_code: "+853"
    },
    {
        image: "MP.svg",
        dial_code: "+1670"
    },
    {
        image: "MQ.svg",
        dial_code: "+596"
    },
    {
        image: "MR.svg",
        dial_code: "+222"
    },
    {
        image: "MS.svg",
        dial_code: "+1664"
    },
    {
        image: "MT.svg",
        dial_code: "+356"
    },
    {
        image: "MU.svg",
        dial_code: "+230"
    },
    {
        image: "MV.svg",
        dial_code: "+960"
    },
    {
        image: "MW.svg",
        dial_code: "+265"
    },
    {
        image: "MX.svg",
        dial_code: "+52"
    },
    {
        image: "MY.svg",
        dial_code: "+60"
    },
    {
        image: "MZ.svg",
        dial_code: "+258"
    },
    {
        image: "NA.svg",
        dial_code: "+264"
    },
    {
        image: "NC.svg",
        dial_code: "+687"
    },
    {
        image: "NE.svg",
        dial_code: "+227"
    },
    {
        image: "NF.svg",
        dial_code: "+672"
    },
    {
        image: "NG.svg",
        dial_code: "+234"
    },
    {
        image: "NI.svg",
        dial_code: "+505"
    },
    {
        image: "NL.svg",
        dial_code: "+31"
    },
    {
        image: "NO.svg",
        dial_code: "+47"
    },
    {
        image: "NP.svg",
        dial_code: "+977"
    },
    {
        image: "NR.svg",
        dial_code: "+674"
    },
    {
        image: "NU.svg",
        dial_code: "+683"
    },
    {
        image: "NZ.svg",
        dial_code: "+64"
    },
    {
        image: "OM.svg",
        dial_code: "+968"
    },
    {
        image: "PA.svg",
        dial_code: "+507"
    },
    {
        image: "PE.svg",
        dial_code: "+51"
    },
    {
        image: "PF.svg",
        dial_code: "+689"
    },
    {
        image: "PG.svg",
        dial_code: "+675"
    },
    {
        image: "PH.svg",
        dial_code: "+63"
    },
    {
        image: "PK.svg",
        dial_code: "+92"
    },
    {
        image: "PL.svg",
        dial_code: "+48"
    },
    {
        image: "PM.svg",
        dial_code: "+508"
    },
    {
        image: "PN.svg",
        dial_code: "+872"
    },
    {
        image: "PR.svg",
        dial_code: "+1939"
    },
    {
        image: "PS.svg",
        dial_code: "+970"
    },
    {
        image: "PT.svg",
        dial_code: "+351"
    },
    {
        image: "PW.svg",
        dial_code: "+680"
    },
    {
        image: "PY.svg",
        dial_code: "+595"
    },
    {
        image: "QA.svg",
        dial_code: "+974"
    },
    {
        image: "RE.svg",
        dial_code: "+262"
    },
    {
        image: "RO.svg",
        dial_code: "+40"
    },
    {
        image: "RS.svg",
        dial_code: "+381"
    },
    {
        image: "RU.svg",
        dial_code: "+7"
    },
    {
        image: "RW.svg",
        dial_code: "+250"
    },
    {
        image: "SA.svg",
        dial_code: "+966"
    },
    {
        image: "SB.svg",
        dial_code: "+677"
    },
    {
        image: "SC.svg",
        dial_code: "+248"
    },
    {
        image: "SD.svg",
        dial_code: "+249"
    },
    {
        image: "SE.svg",
        dial_code: "+46"
    },
    {
        image: "SG.svg",
        dial_code: "+65"
    },
    {
        image: "SH.svg",
        dial_code: "+290"
    },
    {
        image: "SI.svg",
        dial_code: "+386"
    },
    {
        image: "SJ.svg",
        dial_code: "+47"
    },
    {
        image: "SK.svg",
        dial_code: "+421"
    },
    {
        image: "SL.svg",
        dial_code: "+232"
    },
    {
        image: "SM.svg",
        dial_code: "+378"
    },
    {
        image: "SN.svg",
        dial_code: "+221"
    },
    {
        image: "SO.svg",
        dial_code: "+252"
    },
    {
        image: "SR.svg",
        dial_code: "+597"
    },
    {
        image: "SS.svg",
        dial_code: "+211"
    },
    {
        image: "ST.svg",
        dial_code: "+239"
    },
    {
        image: "SV.svg",
        dial_code: "+503"
    },
    {
        image: "SY.svg",
        dial_code: "+963"
    },
    {
        image: "SZ.svg",
        dial_code: "+268"
    },
    {
        image: "TC.svg",
        dial_code: "+1649"
    },
    {
        image: "TD.svg",
        dial_code: "+235"
    },
    {
        image: "TG.svg",
        dial_code: "+228"
    },
    {
        image: "TH.svg",
        dial_code: "+66"
    },
    {
        image: "TJ.svg",
        dial_code: "+992"
    },
    {
        image: "TK.svg",
        dial_code: "+690"
    },
    {
        image: "TL.svg",
        dial_code: "+670"
    },
    {
        image: "TM.svg",
        dial_code: "+993"
    },
    {
        image: "TN.svg",
        dial_code: "+216"
    },
    {
        image: "TO.svg",
        dial_code: "+676"
    },
    {
        image: "TR.svg",
        dial_code: "+90"
    },
    {
        image: "TT.svg",
        dial_code: "+1868"
    },
    {
        image: "TV.svg",
        dial_code: "+688"
    },
    {
        image: "TW.svg",
        dial_code: "+886"
    },
    {
        image: "TZ.svg",
        dial_code: "+255"
    },
    {
        image: "UA.svg",
        dial_code: "+380"
    },
    {
        image: "UG.svg",
        dial_code: "+256"
    },
    {
        image: "US.svg",
        dial_code: "+1"
    },
    {
        image: "UY.svg",
        dial_code: "+598"
    },
    {
        image: "UZ.svg",
        dial_code: "+998"
    },
    {
        image: "VA.svg",
        dial_code: "+379"
    },
    {
        image: "VC.svg",
        dial_code: "+1784"
    },
    {
        image: "VE.svg",
        dial_code: "+58"
    },
    {
        "dial_code": "+1284"
    },
    {
        image: "VI.svg",
        dial_code: "+1340"
    },
    {
        image: "VN.svg",
        dial_code: "+84"
    },
    {
        image: "VU.svg",
        dial_code: "+678"
    },
    {
        image: "WF.svg",
        dial_code: "+681"
    },
    {
        image: "WS.svg",
        dial_code: "+685"
    },
    {
        image: "YE.svg",
        dial_code: "+967"
    },
    {
        image: "YT.svg",
        dial_code: "+262"
    },
    {
        image: "ZA.svg",
        dial_code: "+27"
    },
    {
        image: "ZM.svg",
        dial_code: "+260"
    },
    {
        image: "ZW.svg",
        dial_code: "+263"
    }
]